import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Offline } from '@sentry/integrations'
import "./style.css";

import GlobalProvider from "./providers/GlobalProvider";
import NavProvider from "./providers/NavProvider";
import AccessTokenProvider from "./providers/AccessTokenProvider";
import AlertServiceProvider from "./providers/AlertService";
import LoadingProvider from "./providers/LoadingProvider";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Offline()],
  tracesSampleRate: 1.0
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AccessTokenProvider>
        <GlobalProvider>
          <NavProvider>
            <LoadingProvider>
              <AlertServiceProvider>
                <Sentry.ErrorBoundary fallback={"An error has occurred"}>
                  <App />
                </Sentry.ErrorBoundary>
              </AlertServiceProvider>
            </LoadingProvider>
          </NavProvider>
        </GlobalProvider>
      </AccessTokenProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js");
}
